export default __webpack_public_path__ + "locales/az/PeopleTranslations.json?hash=e5729bf88fe43b31488cea2b3d76714b";